import OptionList from 'models/OptionList';
import Step from 'models/Step';

type URL = {
  urlPricingTool?: string,
  urlHotSale?: string,
  urlPromotionFiveMonths?: string,
  urlHomiePromotion?: string
};

export const SCREEN_SIZE = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl'
};

export const SCREEN_SIZE_WIDTH = {
  [SCREEN_SIZE.XS]: 0,
  [SCREEN_SIZE.SM]: 768,
  [SCREEN_SIZE.MD]: 992,
  [SCREEN_SIZE.LG]: 1200,
  [SCREEN_SIZE.XL]: 1800
};

export const SCREEN_SIZE_MAX_WIDTH = {
  [SCREEN_SIZE.XS]: SCREEN_SIZE_WIDTH[SCREEN_SIZE.SM] - 1,
  [SCREEN_SIZE.SM]: SCREEN_SIZE_WIDTH[SCREEN_SIZE.MD] - 1,
  [SCREEN_SIZE.MD]: SCREEN_SIZE_WIDTH[SCREEN_SIZE.LG] - 1,
  [SCREEN_SIZE.LG]: SCREEN_SIZE_WIDTH[SCREEN_SIZE.XL] - 1,
  [SCREEN_SIZE.XL]: 99999
};

export const LEGAL_PERSON = 'moral';

export const NATURAL_PERSON = 'fisica';

export const DEFAULT_ZERO_FIRST_FEE = 'default_zero_first_fee';

export const PRODUCT_SEEKER = 'product_seeker';

export const COMPANY_TYPES_OPTIONS: Array<OptionList> = [
  new OptionList('0', 'Start up'),
  new OptionList('1', 'PYME'),
  new OptionList('2', 'Corporativo nacional'),
  new OptionList('3', 'Corporativo internacional')
];

export const PRICE_SLIDER = {
  STEP: 500,
  VISUAL_MIN_PRICE_LIMIT: 4000,
  VISUAL_MAX_PRICE_LIMIT: 100000,
  DEFFAULT_MAX_PRICE: 15000
};

export const SURFACE_SLIDER = {
  STEP: 10,
  VISUAL_MIN_SURFACE_LIMIT: 0,
  VISUAL_MAX_SURFACE_LIMIT: 500,
  REAL_MAX_SURFACE_LIMIT: 500000
};

export const DROPDOWN_ALIGNMENT = {
  LEFT: 'left',
  RIGHT: 'right'
};

export const GENDERS = [
  {
    label: 'Masculino',
    value: 'male'
  },
  {
    label: 'Femenino',
    value: 'female'
  }
];

export const STEPS = {
  account: 0,
  profile: 1,
  income: 2,
  references: 3,
  documents: 4,
  payment: 5,
  resume: 10,
  complete: 10,
  previous_landlord: 10,
  extra: 10
};

export const HOME_APPLICATION_STEPPER_ITEMS = [
  new Step('Aplicación', true, false, 'account'),
  new Step('Perfil', true, false, 'profile'),
  new Step('Ingresos', true, false, 'income'),
  new Step('Referencias', true, false, 'references'),
  new Step('Documentos', true, false, 'documents')
];

export const HOME_APPLICATION_STEPPER_ITEMS_EXT = [
  new Step('Aplicación', true, false, 'account'),
  new Step('Perfil', true, false, 'profile'),
  new Step('Ingresos', true, false, 'income'),
  new Step('Referencias', true, false, 'references'),
  new Step('Documentos', true, false, 'documents')
];

export const LEGAL_PERSON_CONST = {
  MAX_IMAGES: 30,
  MIN_CONSTITUTIVE_IMAGES: 1,
  MIN_STATEMENTS_IMAGES: 1,
  MIN_ID_IMAGES: 1
};

export const NATURAL_PERSON_CONST = {
  MAX_IDENTIFICATIONS: 15,
  MIN_IMAGES: 1,
  CREDIT_HISTORY_OPTIONS: [
    new OptionList('credit_card', 'Tarjeta de crédito'),
    new OptionList('other_credits', 'Ninguno de los anteriores')
  ],
  CARD_TIMES: [
    new OptionList(0, 'Menor a 6 meses'),
    new OptionList(6, '6 meses'),
    new OptionList(12, '12 meses'),
    new OptionList(24, '24 meses'),
    new OptionList(25, 'Mayor a 24 meses')
  ]
};

export const SCREENING_PARAMS = {
  CompanyTypes: 'enterprise_types',
  Relationship_moral: 'relationship_moral_person',
  Relationship_physical: 'relationship_physical_person',
  degreeLevels: 'degree_levels',
  seniorityYears: 'seniority_years',
  positionTypes: 'position_types',
  enterpriseTypes: 'enterprise_types',
  EnterpriseSizes: 'enterprise_sizes',
  NumberBranches: 'number_of_branches'
};

export const PAYMENT_TYPES = [
  {
    selected: false,
    text: 'Tarjeta de crédito o débito',
    id: 'tar_deb_cre',
    visible: true
  },
  {
    selected: false,
    text: 'Depósito en efectivo',
    id: 'dep_oxxo',
    visible: true
  },
  {
    selected: false,
    text: 'Transferencia SPEI <strong>(recomendado)</strong>',
    id: 'dep_spei',
    visible: true
  }
];

export const PAYMENT_METHODS = [
  {
    payment_method: 'card',
    subtype: 'visa',
    fee: 0.0,
    fee_type: 'amount'
  },
  {
    payment_method: 'card',
    subtype: 'mast',
    fee: 0.0,
    fee_type: 'amount'
  },
  {
    payment_method: 'card',
    subtype: 'amex',
    fee: 0.0,
    fee_type: 'amount'
  }
];

export const PAYMENT_METHODS_PERCENTAGE = [
  {
    payment_method: 'card',
    subtype: 'visa',
    fee: 0,
    fee_type: 'percent'
  },
  {
    payment_method: 'card',
    subtype: 'mast',
    fee: 0,
    fee_type: 'percent'
  },
  {
    payment_method: 'card',
    subtype: 'amex',
    fee: 0,
    fee_type: 'percent'
  }
];

export const STEPSURL = [
  'cuenta',
  'perfil',
  'ingresos',
  'referencias',
  'documentos'
];

export const LEGAL_STEPSURL = [
  'cuenta',
  'perfil',
  'ingresos',
  'referencias',
  'documentos',
  'pago'
];

export const STEPSURL_EXT = [
  'cuenta',
  'perfil',
  'ingresos',
  'referencias',
  'documentos'
];

export const LEGAL_STEPSURL_EXT = [
  'cuenta',
  'perfil',
  'ingresos',
  'referencias',
  'documentos'
];

export const CUSTOMER_SUCCESS_CATEGORY = [
  {
    item: 'Calendario',
    url: '/dashboard/customer-success/agenda',
    resultFilter: 0
  },
  {
    item: 'Aceptadas',
    url: '/dashboard/customer-success/citas/aceptadas',
    resultFilter: 0
  },
  {
    item: 'Canceladas',
    url: '/dashboard/customer-success/citas/canceladas',
    resultFilter: 0
  },
  {
    item: 'No atendidas',
    url: '/dashboard/customer-success/citas/no-atendidas',
    resultFilter: 0
  }
];

export const CUSTOMER_SUCCESS_ADMIN_CATEGORY = [
  {
    item: 'Vencidas',
    url: '/dashboard/customer-success/admin/citas/vencidas',
    resultFilter: 0
  },
  {
    item: 'A tiempo',
    url: '/dashboard/customer-success/admin/citas/a-tiempo',
    resultFilter: 0
  },
  {
    item: 'Canceladas',
    url: '/dashboard/customer-success/admin/citas/canceladas',
    resultFilter: 0
  },
  {
    item: 'No atendidas',
    url: '/dashboard/customer-success/admin/citas/no-atendidas',
    resultFilter: 0
  }
];

export const REPORT_USERS = {
  TENANT: 0,
  OWNER: 1,
  DASHBOARD: 2
};

export const TENANT_STATUS_NAME = {
  diagnostic: {
    requested: 'Revisando',
    scheduled: 'Asignado',
    visited: 'Primera Visita',
    mediation: 'Mediación',
    approved: 'Aprobado',
    estimated: 'Cotización',
    external_negotiation: 'Externo',
    external_fixed: 'Externo Finalizado',
    not_repaired: 'No',
    canceled: 'No'
  },
  repairment: {
    requested: 'Revisando: Con presupuesto',
    scheduled: 'Cita de servicio',
    visited: 'Finalizado',
    repaired: 'Finalizado',
    canceled: 'No'
  }
};

export const OWNER_STATUS_NAME = {
  diagnostic: {
    requested: 'Revisando',
    scheduled: 'Asignado',
    visited: 'Primera Visita',
    mediation: 'Mediación',
    approved: 'Aprobado',
    estimated: 'Nuevo',
    external_negotiation: 'Externo',
    external_fixed: 'Externo Finalizado',
    not_repaired: 'No',
    canceled: 'No'
  },
  repairment: {
    requested: 'Visita de servicio',
    scheduled: 'Visita de servicio',
    visited: 'Finalizado',
    repaired: 'Finalizado',
    canceled: 'No'
  }
};

export const DASHBOARD_STATUS_NAME = {
  diagnostic: {
    scheduled: '1er visita',
    requested: '1er visita',
    visited: '1er visita',
    canceled: 'Cancelado',
    mediation: 'Mediación',
    estimated: 'Cotización',
    approved: 'Aprobado',
    external_negotiation: 'Externo',
    external_fixed: 'Externo Finalizado',
    not_repaired: 'Cancelado'
  },
  repairment: {
    requested: 'Visita de reparación',
    scheduled: 'Visita de reparación',
    visited: 'Finalizado',
    canceled: 'Cancelado',
    repaired: 'Finalizado'
  }
};

export const REPORT_STATUS_NAME = {
  0: TENANT_STATUS_NAME,
  1: OWNER_STATUS_NAME,
  2: DASHBOARD_STATUS_NAME
};

export const STEP_ACCOUNT = 'account';
export const STEP_PROFILE = 'profile';
export const STEP_INCOME = 'income';
export const STEP_REFERENCES = 'references';
export const STEP_DOCUMENTS = 'documents';
export const STEP_VERIFICATION = 'verification';
export const STEP_PAYMENT = 'payment';
export const STEP_RESUME = 'resume';
export const STEP_COMPLETE = 'complete';
export const STEP_PREVIOUS_LANDLORD = 'previous_landlord';
export const STEP_EXTRA = 'extra';
export const STEP_INCOMPLETE = 'incomplete';

export const STATUS_TO_DISABLED_REPORT = {
  approved: 'approved'
};

export const AVAILABLE_APPLICATION_STATUS = {
  status: {
    pending_payment: {
      cardTitle: 'Ver aplicación'
    },
    documents_requested: {
      cardTitle: 'Ver aplicación'
    },
    approved: {
      cardTitle: 'Ver aplicación'
    },
    declined: {
      cardTitle: 'Ver aplicación'
    },
    screening: {
      cardTitle: 'Evaluar aplicación'
    },
    pending: {
      cardTitle: 'Ver aplicación'
    }
  },

  getCardTitle(currentStatus) {
    return (this.status[currentStatus] || {}).cardTitle;
  }
};

export const TYPECOMISSION = {
  semestrial: {
    label: 'Anual (6 y 6)'
  },
  yearly: {
    label: 'Anual (Un solo pago)'
  },
  monthly: {
    label: 'Mensual'
  }
};

export const APPLICATION_STATUS = {
  screening: {
    status: 'Pendientes por revisar'
  },
  approved: {
    status: 'Aprobadas'
  },
  documents_requested: {
    status: 'Falta de documentos'
  },
  pending_payment: {
    status: 'Falta Pago'
  },
  pending: {
    status: 'Incompletas'
  },
  declined: {
    status: 'Rechazadas'
  }
};

export const APPLICATION_CATEGORIES = [
  {
    name: 'Pendientes por revisar',
    filter: 'screening'
  },
  {
    name: 'Aprobadas',
    filter: 'approved'
  },
  {
    name: 'Faltan documentos',
    filter: 'documents_requested'
  },
  {
    name: 'Falta pago',
    filter: 'pending_payment'
  },
  {
    name: 'Incompletas',
    filter: 'pending'
  },
  {
    name: 'Rechazado',
    filter: 'declined'
  }
];

export const HOME_STATUS = {
  pending_approval: 'Pendiente por aprobar',
  unpublished: 'Baja temporal (Propietario)',
  published: 'Publicado',
  rejected: 'Rechazado',
  reserved: 'Reservado',
  canceled: 'Cancelado',
  temporarily_canceled: 'Baja temporal (Homie)',
  temporarily_canceled_by_posposal: 'Pospuesto',
  rented: 'Rentado',
  in_progress: 'En proceso',
  hidden: 'Oculto',
  waiting_external_photoshooting: 'Esperando sesión de fotos'
};

export const MIN_VALID_PRICE = 4500;

export const FIELD_REQUIRED = 'Campo requerido';

export const DEFAULT_ZERO = 0;

export const RENT_STATUS = {
  started: 'started',
  canceled: 'canceled',
  finished: 'finished',
  negotiation: 'negotiation',
  finishedEarly: 'finished_early'
};

export const HELPERS = {
  legalPolicy: 'legalPolicy',
  petsDeposit: 'petsDeposit',
  deposit: 'deposit',
  backupHomie: 'backupHomie',
  depositHomie: 'depositHomie',
  paymenthelp: 'payment',
  guaranteeDeposit: 'guaranteeDeposit'
};

export const HELPERS_FIRST_PAYMENT = [
  HELPERS.guaranteeDeposit,
  HELPERS.backupHomie,
  HELPERS.paymenthelp
];

export const HELPER_RENEWAL_PAYMENT = [
  HELPERS.backupHomie,
  HELPERS.paymenthelp
];

export const HELPER_MONTHLY_PAYMENT = [HELPERS.paymenthelp];

export const MONTHS = {
  january: 'Enero',
  february: 'Febrero',
  march: 'Marzo',
  april: 'Abril',
  may: 'Mayo',
  june: 'Junio',
  july: 'Julio',
  august: 'Agosto',
  september: 'Septiembre',
  october: 'Octubre',
  november: 'Noviembre',
  december: 'Diciembre'
};

export const PAYMENT_TYPE = {
  advance: 'advance',
  first_payment: 'first_payment',
  rent_pay: 'rent_pay',
  liquidation: 'liquidation'
};

export const TESTIMONIAL_TENANTS = [
  {
    name: 'Nabile Ahumada',
    content: 'Como foránea rentar con Homie fue la mejor experiencia.',
    profession: 'Creadora de contenido',
    picture: '/assets/no_deposit/testimonial_card_images/nabile_color.png'
  },
  {
    name: 'Héctor Trejo (Bully)',
    content:
      'Homie ha modernizado, digitalizado y simplificado la forma de rentar.',
    profession: 'Creador de contenido',
    picture: '/assets/no_deposit/testimonial_card_images/hector_color.png'
  },
  {
    name: 'Jesús Rivas',
    content:
      'Me quitaron el estrés al rentar mi hogar, alguien que te ayude ¡es increíble!',
    profession: 'Creador de contenido',
    picture: '/assets/no_deposit/testimonial_card_images/jesus_color.png'
  }
];

export const TESTIMONIAL_OWNERS = [
  {
    name: 'María de los Ángeles',
    content:
      'Me encantó la promoción efectiva de mi inmueble, la garantía de pago puntual y la asesoría legal.',
    profession: 'Propietaria',
    picture: '/assets/pricing_tool/owner.png'
  }
];

export const BENEFITS_PRICING_TOOL = [
  'Respaldo de pago puntual cada mes',
  'Gestión de citas',
  'Investigación exhaustiva del inquilino',
  'Promoción en múltiples listados inmobiliarios',
  'Asesoría de nuestro equipo en todo momento',
  'Comisión única equivalente al 50% de una renta',
  'Tarifa fija por administración de $450 MXN'
];

export const BENEFITS_PROMOTION = [
  'Respaldo de pago puntual cada mes',
  'Gestión de citas',
  'Investigación exhaustiva del inquilino',
  'Promoción en múltiples listados inmobiliarios',
  'Asesoría de nuestro equipo en todo momento',
  'Comisión única equivalente al 50% de una renta',
  'Tarifa fija por administración de $450 MXN'
];

export const INFO_ICON = '/assets/no_deposit/tooltip.svg';

export const MIN_PRICE = 4000;

export const LOCATION_IDS_KEY = {
  city: 'city_ids',
  neighborhood: 'neighborhood_ids'
};

export const MEXICO_CODE = 52;

export const CURRENCY_MXN = 'mxn';

export const MIN_CARACTER = 2;

export const NEED_MORE_CARACTER = `Ingresar más de ${MIN_CARACTER} caracteres`;

export const SEARCHING_LABEL = 'Buscando....';

export const NOT_RESULTS_FOUND = 'No se encontraron resultados';

export const ONLY_LETTERS = 'Ingresar solo letras';

export const ONLY_INTEGER = 'Sólo numero entero';

export const NO_FOUND_OPTIONS = [{ value: '', label: NOT_RESULTS_FOUND }];

export const MIN_MESSAGE = (min: number = 0) => `Debe ser mayor a ${min} MXN`;

export const MAX_MESSAGE = (max: number = 0) =>
  `No debe ser mayor a ${max} MXN`;

export const BENEFITS_HOT_SALE = [
  'Renta sin aval',
  'Rentar sin depósito*',
  'Sin trámites complicados',
  'Proceso 100% digital',
  'Asesoría de nuestro equipo en todo momento',
  'Descuentos exclusivos en muebles y mudanza'
];

export const HOMIE_CONFIG_KEY = {
  requestCreditReport: 'permission.for.request.credit.report',
  markAsCandidateNoDeposit: 'permission.for.mark.as.candidate.no.deposit',
  makeAdvancePayment: 'permission.for.make.advance.payment',
  changeRentFee: 'permission.for.change.rent.fee',
  reactivateRent: 'reactivate.rent',
  changeRentPrice: 'permission.for.change.rent.price',
  addMonthsRent: 'add.months.rent',
  changePaymentScheme: 'permission.for.change.rent.payment.scheme'
};

export const PROMOTIONS_NAME = {
  paymentSchemas: 'Esquema de pagos',
  rentFeeForOwner: 'Referidos',
  riskType: 'Tipo de Riesgo'
};

const CURRENT_YEAR = new Date().getFullYear();

export const CURRENT_DATE = new Date();
export const END_DATE = new Date('2022-09-30').getFullYear();

export const START_HOMIE_BANNER_PROMOTION = new Date(`${CURRENT_YEAR}-08-15`);

export const END_HOMIE_BANNER_PROMOTION = new Date(`${END_DATE}-09-30 24:00`);

export const SHOW_RIBBON_PROMOTION = false;

export const IS_OUT_DATE_HOMIE_PROMOTION =
  CURRENT_DATE <= START_HOMIE_BANNER_PROMOTION ||
  CURRENT_DATE >= END_HOMIE_BANNER_PROMOTION;

export const URL_PAGE: URL = {
  urlPricingTool: '/propietario/calculadorahomie',
  urlHotSale: '/hotsale?campaign=homie_home',
  urlPromotionFiveMonths:
    '/propietario/calculadorahomie?utm_source=home&utm_medium=site&utm_campaign=5meses',
  urlHomiePromotion: '/inquilino/nodeposito'
};

export const SET_URL_LANDING = IS_OUT_DATE_HOMIE_PROMOTION
  ? URL_PAGE.urlPricingTool
  : '/propietario/calculadorahomie';

export const LOAN_LIMIT = 240000;

export const PAYMENT_NAME = {
  convenience_store: 'Efectivo',
  spei: 'Transferencia',
  card: 'Tarjeta'
};
